// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { N300 } from '@atlaskit/theme/colors';
import { type Theme } from '../theme/types';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledFooter = styled.footer({
	textAlign: 'center',
	marginTop: 'auto',
	padding: `${token('space.200', '16px')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PoweredBy = styled.div<{ theme: Theme }>(
	{
		font: token('font.body.small'),
		display: 'inline-flex',
		alignItems: 'center',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ theme }) =>
		`color: ${theme.overrideStyles?.poweredBy?.color || token('color.text.subtlest', N300)} ;`,
);
